var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.data && _vm.params.data.version === 'v3')?_c('CampaignActionsDropdown',{attrs:{"campaign":_vm.params.data}}):_c('span',{staticClass:"review-buttons cursor-not-allowed text-gray-400"},[_vm._v("\n    Campaign Archived\n")])}
var staticRenderFns = []

export { render, staticRenderFns }